import { createUseStyles } from 'react-jss'
export const style = {
  button: {
    padding: '6px'
  },
  icon: {
    fontSize: '12px',
    position: 'relative',
    paddingBottom: '1px'
  }
}

export const useStyles = createUseStyles(style)
